<template>
  <div v-if="auth.user.selectedAccess.can_manage_staff">
    <loading-spinner v-if="!staff && !error" />

    <!-- Error state -->
    <div v-if="error" class="container mt-4">
      <b-alert show variant="danger">
        <h4 class="alert-heading">
          {{ getLabel('ERROR') || 'Error' }}
        </h4>
        <p>{{ error }}</p>
        <hr />
        <b-button variant="outline-danger" @click="goBack">
          <i class="fa fa-arrow-left" /> {{ getLabel('GO_BACK') || 'Go Back' }}
        </b-button>
        <b-button variant="outline-secondary" class="ml-2" @click="retry">
          <i class="fa fa-refresh" /> {{ getLabel('RETRY') || 'Retry' }}
        </b-button>
      </b-alert>
    </div>

    <app-header
      v-if="staff"
      :title="staff.staff_name"
      :subtitle="`${getLabel('STAFF')} #${staff.staff_id}`"
    >
      <template #col-right>
        <div v-if="auth.user.selectedAccess.can_manage_staff">
          <b-button
            v-router-link="{ name: 'staff-editor', query: { id: staff.id } }"
            variant="primary"
            size="lg"
          >
            <i
              class="fa fa-pencil-square-o"
              style="font-size:20px"
            />&nbsp;<span v-label-key="'EDIT_STAFF'">Edit Staff</span>
          </b-button>
        </div>
      </template>
    </app-header>

    <b-container>
      <div v-if="staff">
        <b-row>
          <b-col md="4">
            <b-card no-body class="mt-3">
              <b-card-header>
                <span v-label-key="'ABOUT'">About</span>
              </b-card-header>
              <b-list-group>
                <b-list-group-item>
                  <h5 v-label-key="'STAFF_LOGIN_ID'">Staff Login ID</h5>
                  <p>{{ staff.staff_id ? staff.staff_id : '' }}</p>
                </b-list-group-item>

                <b-list-group-item>
                  <div class=" d-flex align-items-center">
                    <h5
                      v-label-key="'STAFF_LOGIN_PASSWORD'"
                      style="margin-bottom:0; margin-right:4px;"
                    >
                      Staff Login Password &nbsp;
                    </h5>
                    <b-button
                      size="sm"
                      variant="outline-secondary"
                      @click="showPassword = !showPassword"
                    >
                      <!-- SVG eye icon -->
                      <i
                        :class="showPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"
                      ></i>
                    </b-button>
                  </div>
                  <p v-if="showPassword">
                    {{ staff.staff_password ? staff.staff_password : '' }}
                  </p>
                  <p v-else>••••••••</p>
                </b-list-group-item>

                <b-list-group-item>
                  <h5 v-label-key="'CREATED'">Created</h5>
                  <p>{{ staff.created_at | moment('YYYY-MM-DD') }}</p>
                </b-list-group-item>
                <b-list-group-item>
                  <h5 v-label-key="'STORE'">Store</h5>
                  <p>{{ staff.store_name ? staff.store_name : 'No Store' }}</p>
                </b-list-group-item>
                <b-list-group-item>
                  <h5 v-label-key="'DISTRIBUTOR'">Distributor</h5>
                  <p>
                    {{
                      staff.distributor_name
                        ? staff.distributor_name
                        : 'No Distributor'
                    }}
                  </p>
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </b-col>
        </b-row>
      </div>
    </b-container>
  </div>
</template>
<script>
import $auth from '@/services/auth';
import $api from '@/services/api';
import LoadingSpinner from '@/components/LoadingSpinner';
import AppHeader from '@/components/AppHeader';
import { mapGetters } from 'vuex';

export default {
  components: {
    LoadingSpinner,
    AppHeader,
  },
  computed: {
    ...mapGetters('translations', {
      getLabel: 'getLabel',
    }),
  },
  data() {
    return {
      auth: $auth,
      staff: null,
      showPassword: false,
      error: null,
    };
  },
  created() {
    this.refreshData();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    retry() {
      this.error = null;
      this.refreshData();
    },
    refreshData() {
      $api
        .get(`/v1/dashboard/retailstaff/${this.$route.params.id}`)
        .then((staff) => {
          this.staff = staff;
        })
        .catch((error) => {
          this.error = error.message || 'Failed to load staff details';
        });
    },
  },
};
</script>

<style scoped>
a {
  color: black;
}
</style>
